<template>
  <div class="h-container">
    <h3 class="mb-10 text-center md:mb-11 xl:mb-12">{{ t['w.module.room_categories.title']() }}</h3>
    <div class="h-gap grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6">
      <NuxtLink
        v-for="(card, cardIndex) in props.data"
        :key="`room-card-${cardIndex}`"
        :to="card.url"
        class="h-translate-y-0 hover:h-translate-y-1 group text-center transition-transform duration-500"
      >
        <OnImg
          class="aspect-[4/3] h-auto w-full rounded-2xl object-cover transition-shadow group-hover:shadow-05"
          fit="cover"
          width="320"
          height="240"
          sizes="320px"
          :alt="card.title"
          :title="card.title"
          :src="card.imageUrl"
        />
        <span class="subheading mb-3.5 mt-3 block hyphens-auto group-hover:text-text-strong sm:mb-4 md:mb-5 xl:mb-4">{{ card.title }}</span>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import OnImg from '~/components/on-img/OnImg.vue'
import * as t from '~/messages'

interface RoomCategory {
  title: string
  url: string
  imageUrl: string
}

const props = defineProps<{ data: RoomCategory[] }>()
</script>
